import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

const mediaMix = [
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    title: 'TNO Digest (SEO)',
    subtitle:
      'Dos artículos semanales en tnonetwork.com: centro de respuestas para búsquedas orgánicas sobre salud y bienestar sexual.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Micros con humor',
    subtitle:
      'Cápsulas «Minuto Prudence» (30 s) escritas y presentadas por Karla Aleska y Mariana: educación con risa, en rotativa y dentro de 2do Escalón. Lower thirds en vivo en la grilla Radio Visual.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Redes co-publicadas',
    subtitle:
      'Inserts, clips y carruseles informativos en las plataformas digitales de TNO Network con co-acreditación de marca.',
  },
];

const AboutSection = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 10 }}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          About
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Aliado de medios: TNO Network · TNO Media Lab 888
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" maxWidth={720} margin="0 auto">
          Campaña <em>Placer Inteligente, Decisiones Seguras</em>: inbound 360° con humor inteligente, micros de Karla
          Aleska y Mariana, autoridad editorial y presencia en 2do Escalón.
        </Typography>
      </Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 600 }}
            gutterBottom
            color="primary"
          >
            Mix de medios
          </Typography>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Digest, señal y redes
          </Typography>
          <List disablePadding>
            {mediaMix.map((item, index) => (
              <ListItem key={index} disableGutters sx={{ alignItems: 'flex-start' }} data-aos="fade-up">
                <ListItemAvatar>
                  <Box
                    component={Avatar}
                    variant="rounded"
                    bgcolor={`${theme.palette.primary.light}33`}
                    color={theme.palette.primary.dark}
                  >
                    {item.icon}
                  </Box>
                </ListItemAvatar>
                <ListItemText
                  primary={item.title}
                  secondary={item.subtitle}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="center" alignItems="center" data-aos={isMd ? 'fade-left' : 'fade-up'}>
          <Box
            component={Card}
            boxShadow={4}
            borderRadius={2}
            overflow="hidden"
            sx={{ bgcolor: theme.palette.alternate.main, width: '100%' }}
          >
            <Box p={3}>
              <Typography variant="overline" color="primary" fontWeight={700}>
                Cliente
              </Typography>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Prudence
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Líder en protección y bienestar íntimo. La propuesta posiciona a la marca como referente en prevención,
                salud reproductiva y decisiones informadas.
              </Typography>
              <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Producción TNO
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Condiciones técnicas audiovisuales y editoriales a cargo de TNO Network, con reposición por fuerza
                  mayor ante contingencias de infraestructura.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutSection;
